import {
  ListChecks, Phone, Users, Mail, Presentation, Ruler, Hammer, Wrench, Handshake,
  ClipboardCheck, GraduationCap, ShieldCheck, CalendarDays,
} from "lucide-react";

/** Ikona ke každému typu aktivity (Nastavení → typy). Neznámý typ = kalendář. */
const IKONY = {
  "Úkol": ListChecks,
  "Hovor": Phone,
  "Schůzka": Users,
  "E-mail": Mail,
  "Prezentace": Presentation,
  "Zaměření": Ruler,
  "Instalace": Hammer,
  "Oprava": Wrench,
  "Předání": Handshake,
  "Servisní prohlídka": ClipboardCheck,
  "Školení obsluhy": GraduationCap,
  "Záruční oprava": ShieldCheck,
};

export const ikonaTypu = (typ) => IKONY[typ] || CalendarDays;

/** Krátká jména do výběru lidí: křestní jméno, u shody i iniciála příjmení
 *  („Petr B.", „Petr H."); přihlášený je „Já". */
export function kratkaJmena(lide, mujId) {
  const krestni = (m) => (m.name || "").trim().split(/\s+/)[0] || "?";
  const pocet = {};
  lide.forEach((m) => { const k = krestni(m); pocet[k] = (pocet[k] || 0) + 1; });
  const out = {};
  lide.forEach((m) => {
    if (m.id === mujId) { out[m.id] = "Já"; return; }
    const k = krestni(m);
    const prijmeni = (m.name || "").trim().split(/\s+/).slice(1).join(" ");
    out[m.id] = pocet[k] > 1 && prijmeni ? `${k} ${prijmeni[0]}.` : k;
  });
  return out;
}

/** Upozornění u úkolu (zvoneček, telefon a počítač): minuty před začátkem, 0 = v čas, −1 = žádné.
 *  Server bere jen tyto volby. */
export const UPOZORNENI = [
  [0, "v čas"], [15, "15 min předem"], [60, "hodinu předem"], [1440, "den předem"], [2880, "2 dny předem"],
];
export const textUpozorneni = (min) => (UPOZORNENI.find(([m]) => m === min) || [])[1] || "";
/** E-mail navíc jen u schůzek a návštěv — u úkolů, hovorů a e-mailů stačí upozornění. */
export const pripominkaEmailem = (typ) => !["Úkol", "Hovor", "E-mail"].includes(typ);
